import React, { useState, useEffect } from 'react'
import {
  Button,
  ButtonsContainer,
  OnboardTitle,
  OnboardSubtitle,
  CircularProgress,
} from 'components/Antifraude'
import { getOcrTypes } from 'redux/reducers/ocr'
import { useSelector, useDispatch } from 'react-redux'

import CnhFront from 'assets/cnh_front.svg'
import RgFront from 'assets/rg_front.svg'
import RneFront from 'assets/rne_front.svg'

import validateStageOnboarding from 'utils/validateStage'
import { roles } from 'utils/constants/roles'

import Container from './styles'

export default (props) => {
  const { history } = props
  const dispatch = useDispatch()

  const { token } = useSelector((state) => state.token)
  const { types, loading } = useSelector((state) => state.ocr)

  const [options, setOptions] = useState([])
  const [selectedDoc, setSelectedDoc] = useState(null)
  const [buttonEnabled, setButtonEnabled] = useState(false)
  const [loadingStage, setLoadingStage] = useState(false)

  const handleLoading = (newState) => {
    setLoadingStage(newState)
  }

  function getOptions() {
    const op = []

    const cnh = {
      id: 1,
      type: 'cnh',
      label: 'CNH',
      selected: false,
      image: CnhFront,
    }
    const rg = {
      id: 2,
      type: 'rg_front',
      label: 'RG ou CIN',
      selected: false,
      image: RgFront,
    }
    const rne = {
      id: 3,
      type: 'rne_front',
      label: 'RNE ou RNM',
      selected: false,
      image: RneFront,
    }

    op.push(cnh)
    op.push(rg)
    op.push(rne)

    setOptions(op)
  }

  function chooseOption() {
    history.replace({
      pathname: '/ocr-upload',
      state: {
        label: selectedDoc.label,
        type: selectedDoc.type,
      },
    })
  }

  function handleSelectDoc(doc) {
    setSelectedDoc(doc)
    setButtonEnabled(true)
  }

  useEffect(() => {
    validateStageOnboarding(token, history, roles.DOCUMENT_OCR, handleLoading)
  }, [])

  useEffect(() => {
    if (types.length === 0) {
      dispatch(getOcrTypes({ token: token }))
    } else if (options.length === 0) {
      getOptions()
    }
  }, [types, options])

  return (
    <Container
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.4 }}
    > 
      {loadingStage ? (
        <div className="loading">
          <div
            className="loading__container"
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <CircularProgress />
          </div>
        </div>
      ) : (
        <React.Fragment>
          <OnboardTitle>
            Vamos iniciar com a validação do seu documento
          </OnboardTitle>

          <OnboardSubtitle>
            Para garantir o sucesso do processo, escolha dentre os documentos
            abaixo, aquele com a foto mais recente. Esse documento deve estar
            preservado, sem borrões, rasgões, riscos ou amassado.
          </OnboardSubtitle>

          <ul className="documents">
            {options?.map((doc) => (
              <li key={doc.id}>
                <button
                  id={doc.id}
                  type="button"
                  className={
                    selectedDoc && selectedDoc.id === doc.id ? 'selected' : ''
                  }
                  onClick={() => handleSelectDoc(doc)}
                >
                  {doc.label}
                  <img src={doc.image} alt="" />
                </button>
              </li>
            ))}
          </ul>

          {loading ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <ButtonsContainer>
              <Button
                onClick={chooseOption}
                disabled={!buttonEnabled}
              >
                Continuar
              </Button>
            </ButtonsContainer>
          )}
        </React.Fragment>
      )}
    </Container>
  )
}
